import { render, staticRenderFns } from "./CannedResponse.vue?vue&type=template&id=6441955a&"
import script from "./CannedResponse.vue?vue&type=script&setup=true&lang=js&"
export * from "./CannedResponse.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports